<script setup lang="ts">
    import KFormFieldDisplay from "@/components/forms/displays/FormFieldDisplay/KFormFieldDisplay.vue";
    import KSection from "@/components/generic/KSection.vue";
    import { useStore } from "@/store";
    import { LakemedelDisplay } from "@/tabs/Receptforskrivning/types";
    import { computed, ref, toRefs } from "vue";

    const store = useStore();

    const props = withDefaults(
        defineProps<{
            mallId?: string;
        }>(),
        {}
    );

    const { mallId } = toRefs(props);

    const lakemedelId = ref<string | null>(
        store.getters["receptforskrivningMall/mallById"]({
            id: mallId?.value,
        })?.forskrivning?.items?.[0]?.lakemedelId
    );

    const lakemedel = computed<LakemedelDisplay | undefined>(() =>
        store.getters["lakemedel/lakemedelById"]({ id: lakemedelId.value, displayMode: true })
    );

    defineExpose({
        // Plockas upp av KForm
        formListeners: [
            {
                fieldNames: ["lakemedelId"],
                action: ({ values }) => {
                    if (values.lakemedelId) {
                        lakemedelId.value = values.lakemedelId as string;
                    }
                },
            },
        ] as Array<{
            fieldNames: string[];
            action: ({ values }: { values: { [key: string]: unknown } }) => void | Promise<void>;
        }>,
    });

    const fetchTidsenheter = async () => {
        await store.dispatch("nll/fetchTidsenheter", {});

        return store.getters["nll/tidsenheterSubset"]({ subsetName: "default" });
    };
</script>

<template>
    <KSection name="expedieringsdetaljer" heading="Expedieringsdetaljer" :number="3">
        <div class="form-content readable-disabled">
            <div class="form-section span-all">
                <KFormFieldDisplay
                    name="forpackning"
                    label="Förpackning"
                    :value="lakemedel?.forpackning"
                    showEmptyValue
                />
                <KNumber name="antal_uttag" label="Antal uttag" validation="minvalue:1" />
                <KNumber name="forpackningar_per_uttag" label="Förpackningar per uttag" validation="minvalue:1" />
            </div>
            <div class="form-section">
                <KCheckbox name="startforpackning" label="Startförpackning" valueType="boolean" />
                <KCheckbox name="substitution_tillaten" label="Substitution tillåten" valueType="boolean" />
            </div>
            <div class="form-section">
                <KNumber name="tid_mellan_uttag" label="Expedieringsintervall" validation="minvalue:0" />
                <KAutocomplete name="tidsenhet" label="Tidsenhet" disabled :options="fetchTidsenheter" />
            </div>
        </div>
    </KSection>
</template>

<style scoped lang="scss">
    .expedieringsdetaljer {
    }
</style>
